enum MenuItemCategory {
  Food = 0,
  AlcoholicBeverage = 1,
  NonalcoholicBeverage = 2,
  Other = 3,
  SpecialOffer = 4,
}

export { MenuItemCategory };
